import { useContext } from "react";
import { CurrentAnswerContext } from "../CurrentAnswerContext";

export function useCurrentAnswer() {
  const context = useContext(CurrentAnswerContext);
  if (!context) {
    throw new Error(
      "useCurrentAnswer must be used within a CurrentAnswerProvider"
    );
  }
  return context;
}
